import React, { useCallback, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { refreshSignedMedia } from "../../redux/actions/mediaActions";
import { SignedMediaContext } from "./SignedImage";

// The profile and the job being completed stay in Redux for the whole session, but the signed
// links in them stop working after a few hours. Reload them when the tab comes back after a while.

const DEFAULT_STALE_MINUTES = 45;
const staleAfterMs = (Number(process.env.REACT_APP_MEDIA_REFRESH_MINUTES) || DEFAULT_STALE_MINUTES) * 60 * 1000;

export function SignedMediaProvider({ auth, children }) {
  const dispatch = useDispatch();
  const profile = useSelector((state) => state.profile);
  const completingJob = useSelector((state) => state.completingJob);
  const loadedAt = useRef(Date.now());

  // Any (re)load replaces these objects, so their links are as fresh as the last change
  useEffect(() => {
    loadedAt.current = Date.now();
  }, [profile, completingJob]);

  const refresh = useCallback(() => dispatch(refreshSignedMedia(auth)), [dispatch, auth]);

  useEffect(() => {
    const onVisibilityChange = () => {
      if (document.visibilityState === "visible" && Date.now() - loadedAt.current > staleAfterMs) refresh();
    };
    document.addEventListener("visibilitychange", onVisibilityChange);
    return () => document.removeEventListener("visibilitychange", onVisibilityChange);
  }, [refresh]);

  return <SignedMediaContext.Provider value={refresh}>{children}</SignedMediaContext.Provider>;
}

SignedMediaProvider.propTypes = {
  auth: PropTypes.object.isRequired,
  children: PropTypes.node,
};
